import { useTrailers } from '@api/useTrailers'
import { UploadDownloadButtons } from '@components/_SiteWide/UploadStatus/UploadDownloadButtons'
import { useSecurityContext } from '@components/Navigation/SecurityContext'
import { GraviGrid, TextCell, useGridFetch } from '@gravitate-js/excalibrr'
import api from '@utils/api'
import React, { useCallback, useMemo } from 'react'
import { useUserSettings } from '@hooks/settings'
import { gridViewManager } from '@/utils/grid'

const STORAGE_KEY = 'trailer_config'

export function TrailerConfig() {
  const { useGetTrailerConfigQuery } = useTrailers()
  const { data, isPending, refetch: refresh } = useGetTrailerConfigQuery()
  const gridAPIRef = React.useRef(null)
  const { scopes } = useSecurityContext()
  const canEdit = scopes.admin?.vehicle_write
  const { updateSetting } = useUserSettings()

  const columnDefs = useMemo(getColumnDefs, [])
  const getRowId = useCallback((row) => row?.data?.id, [])
  const agPropOverrides = useMemo(
    () => ({
      columnDefaultOverrides: {
        resizeable: false,
        flex: undefined,
      },
      rowGroupPanelShow: 'always',
      getRowId,
    }),
    []
  )
  return (
    <GraviGrid
      externalRef={gridAPIRef}
      controlBarProps={{
        title: 'Trailer Configuration Management',
        actionButtons: (
          <UploadDownloadButtons
            downloadEP={api.downloadTrailerConfig}
            uploadEP={canEdit && api.uploadTrailerConfigs}
            fileName='Trailer Configs.xlsx'
            refreshCallback={refresh}
          />
        ),
      }}
      storageKey={STORAGE_KEY}
      loading={isPending}
      agPropOverrides={agPropOverrides}
      columnDefs={columnDefs}
      rowData={data?.rows}
      onGridConfigChanged={(config) => updateSetting(`gridConfig::${STORAGE_KEY}`, config)}
      {...gridViewManager(STORAGE_KEY, updateSetting)}
    />
  )
}

const getColumnDefs = () => [
  {
    field: 'trailer_config',
    headerName: 'Trailer Config',
    filter: true,
    flex: 2,
    rowGroup: true,
    hide: true,
    cellRenderer: ({ value }) => <TextCell value={value} weight='bold' />,
  },
  {
    field: 'code',
    flex: 3,
    minWidth: 300,
  },

  {
    field: 'compartment_1',
    headerName: 'Compartment 1',
  },
  {
    field: 'compartment_2',
    headerName: 'Compartment 2',
  },
  {
    field: 'compartment_3',
    headerName: 'Compartment 3',
  },
  {
    field: 'compartment_4',
    headerName: 'Compartment 4',
  },
  {
    field: 'compartment_5',
    headerName: 'Compartment 5',
  },
  {
    field: 'compartment_6',
    headerName: 'Compartment 6',
  },
  {
    field: 'compartment_7',
    headerName: 'Compartment 7',
  },
]
